import { withDeliveryOptionsProps } from 'viewModel/productPage/deliveryOptions/withDeliveryOptionsProps.js';
import DeliveryOptions from 'components/ProductPage/DeliveryOptions/DeliveryOptions';

export default withDeliveryOptionsProps(DeliveryOptions);
